<template>
  <b-container class="text-center">
    <img
      class="d-block mx-auto mb-1"
      src="../assets/logo_default.svg"
      alt
      width="100"
      height="100"
    />
    <p>Logging out ...</p>
    <b-modal
      v-model="showModal"
      v-bind:title="modalTitle"
      @hidden="onModalHidden"
      centered
      ok-only
    >
      <p>{{ modalMessage }}</p>
    </b-modal>

    <DialogYesNo v-model="dialogVisible" @ok="logout" @hidden="goBack">
      <p>
        You are signed in in as
        <b>{{ userName }}</b> and about to sign out.
      </p>
      <p>
        If you did not write down your guest password when asked to do so, you
        will not be able to login again.
      </p>
      <p>Are you sure you want to do this?</p>
    </DialogYesNo>
  </b-container>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo";

export default {
  name: "Logout",
  components: { DialogYesNo },
  data() {
    return {
      username: "",
      usernameValid: true,
      showModal: false,
      modalTitle: "Error",
      modalMessage: "Something went wrong.",
      goHomeOnDismiss: false,
      dialogVisible: false,
      loggingOut: false
    };
  },
  computed: {
    userName() {
      return this.$store.state.userName;
    }
  },
  created() {
    this.$topquiz.on(this, "logout_error", () => {
      this.$router.push("/");
    });

    this.$topquiz.on(this, "logout_success", () => {
      this.goHomeOnDismiss = true;
      this.showErrorModal("Log out success!", "You have been logged out.");
      localStorage.removeItem("session_key");
    });

    if (this.$store.state.userRole == 0) {
      this.dialogVisible = true;
      return;
    }

    this.logout();
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    showErrorModal: function(title, message) {
      this.modalTitle = title;
      this.modalMessage = message;
      this.showModal = true;
    },
    onModalHidden: function() {
      if (this.goHomeOnDismiss) {
        this.$router.replace("/");
      }
    },
    goBack() {
      if (this.loggingOut) {
        return;
      }

      this.$router.go(-1);
    },
    logout() {
      this.loggingOut = true;
      this.$topquiz.sendCommand("logout", this.$topquiz.SessionKey);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 500px;
}
</style>
